import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENROLLED_USER_SESSION } from 'src/app/@constants/local-storage-key-constants';
import { EventEnrollUserSessionResponse } from 'src/app/@data-services/event-enroll/event-enroll.data-model';
import { getLocalStorageItem } from 'src/app/@utils/local-storage-util';
import { environment } from 'src/environments/environment';
import { ExternalRegistrationStateService } from '../@store/external-registration-state.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const externalRegistrationState = inject(ExternalRegistrationStateService);
  const registrationId = externalRegistrationState.$registrationId();
  const session = getLocalStorageItem<EventEnrollUserSessionResponse>(
    ENROLLED_USER_SESSION
  );
  const userSessionId = session?.sessionID || '';
  let reqWithHeader = req.clone({
    headers: req.headers
      .set('X-Api-Key', environment.X_API_KEY)
      .set('X-User-Session', userSessionId),
  });

  if (req.body && typeof req.body === 'object') {
    reqWithHeader = reqWithHeader.clone({
      body: { ...req.body, registrationId },
    });
  }

  return next(reqWithHeader);
}
